import { filterZeroArrays, empty, handleize} from '@/lib/utils'
const MEDICAL_PROFF = ['PA', 'MD', 'NP', 'DO', 'Other Medical Professional'].map(handleize)
export default {
  methods: {
    getIconColor(required, preferred) {
      if(required) {
        return 'red'
      } else {
        return 'amber darken-3'
      }
    },
    hasLORRequirement (requirement, allRequiements, index) {
      const userLOR = []
      let counter = 0
      for (const req of allRequiements) {
        const isValid = this.userLORs.find((lor) => {
          return !userLOR.includes(lor.id) && this.validateLOR(lor, req, true)
        })
        if (isValid) {
          userLOR.push(isValid.id)
        }


        if (counter === index) {
          return isValid
        }
        counter += 1
      }
      return false
    },

    validateLOR (lor, requirement, forceValidate = false) {
      const anyMedicalProf = !empty(requirement.writer_title) ? handleize(requirement.writer_title) == 'any-medical-professional' : false
      const { writer_title = '', writer_time_known } = lor
      // Validate Writer Title
      if (!empty(requirement.writer_timeframe_month)) {
        // If user has not provided months
        if (empty(writer_time_known)) return false
        // If required months greater than users
        if (Number(requirement.writer_timeframe_month) > Number(writer_time_known)) return false
      }
      if (!requirement.required && !forceValidate) return true
      if (!empty(requirement.writer_title)) {
        if (anyMedicalProf && !MEDICAL_PROFF.includes(handleize(writer_title))) return false
        if (!anyMedicalProf && handleize(requirement.writer_title) !== handleize(writer_title)) return false
      }

      if (empty(!requirement.writer_timeframe_year)) {
        // If user has not provided months
        if (empty(writer_time_known)) return false

        // Convert Year to month and compare
        if ((Number(requirement.writer_timeframe_year) * 12) > Number(writer_time_known)) return false
      }
      return true
    },
  },
  computed: {
    hasRequiredLORs () {
      const userLORs = this.userLORs
      const minimumLors = empty(this.savedSchool.letter_of_recommendation_minimum_letters_required) ? 0 : Number(this.savedSchool.letter_of_recommendation_minimum_letters_required)
      if (this.savedSchool.letter_of_recommendation_specific_writers_required) {
        const usedLor = []
        const allSpecific = this.schoolRequiredEvaluations.every((requirement) => {
          const foundMatch = userLORs.find((lor) => !usedLor.includes(lor.id) && this.validateLOR(lor, requirement))
          if (foundMatch) {
            usedLor.push(foundMatch.id)
          }
          return foundMatch
        })
        if (!allSpecific) return false

        if (this.schoolEitherEvaluations.length) {
          const allSpecific = this.schoolEitherEvaluations.some((requirement) => {
            return userLORs.find((lor) => this.validateLOR(lor, requirement))
          })

          if (!allSpecific) return false
        }
      }

      const letterCondition = [
        ...this.schoolRequiredEvaluations
      ]

      return userLORs.length >= letterCondition.length && userLORs.length >= minimumLors
    },
    validCompletedEvaluations () {
      let evaluations = []
      const userLORs = this.userLORs
      const minimumLors = empty(this.savedSchool.letter_of_recommendation_minimum_letters_required) ? 0 : Number(this.savedSchool.letter_of_recommendation_minimum_letters_required)
      if (!minimumLors) return []

      if (this.savedSchool.letter_of_recommendation_specific_writers_required) {
        const usedLor = []
        this.schoolRequiredEvaluations.forEach((requirement) => {
          const foundMatch = userLORs.find((lor) => !usedLor.includes(lor.id) && this.validateLOR(lor, requirement))
          if (foundMatch) {
            usedLor.push(foundMatch.id)
            evaluations.push(foundMatch)
          }
        })

        if (this.schoolEitherEvaluations.length) {
          let found = false
          this.schoolEitherEvaluations.forEach((requirement) => {
            if (found) return
            const match = userLORs.find((lor) => !evaluations.find(({ id }) => id == lor.id) && this.validateLOR(lor, requirement))
            if (match) {
              found = true
              evaluations.push(match)
            }
          })
        }
      } else {
        evaluations = userLORs
      }
      return evaluations
    },
    totalLORSRequired () {
      const count = empty(this.savedSchool.letter_of_recommendation_minimum_letters_required) ? 0 : Number(this.savedSchool.letter_of_recommendation_minimum_letters_required)
      return count
    },
    userLORs () {
      const validEvaluations = this.validEvaluations
      const letterCondition = filterZeroArrays([
        ...this.schoolRequiredEvaluations,
        ...this.savedSchool.letter_of_recommendation_either_writers_title
      ])

      if (letterCondition.length) {
        const passedEvaluations = letterCondition.reduce((passedValidations, requirement) => {
          const matchingEvaluation = validEvaluations.find((lor) => {
            if (passedValidations.find(({ id }) => lor.id === id)) return false // LOR already used
            return this.validateLOR(lor, requirement)
          })

          if (matchingEvaluation) passedValidations.push(matchingEvaluation)

          return passedValidations
        }, [])

        const otherValidations = validEvaluations.filter(({ id }) => {
          return !passedEvaluations.some((v) => v.id === id)
        })

        if (passedEvaluations.length < this.schoolRequiredEvaluations.length) return passedEvaluations
        return passedEvaluations.concat(otherValidations)
      }

      if (letterCondition.length === 0) return validEvaluations

      return validEvaluations.filter((lor) => {
        if (letterCondition.length === 0) return lor
        return letterCondition.some((requirement) => {
          return this.validateLOR(lor, requirement)
        })
      })
    },
    validEvaluations () {
      return this.userEvaluations.filter(({ evaluation_status }) => handleize(evaluation_status) !== handleize("Not Yet Requested"))
    },
    schoolEitherEvaluations () {
      return filterZeroArrays(this.savedSchool.letter_of_recommendation_either_writers_title).map((lor) => {
        return { ...lor, required: !this.savedSchool.letter_of_recommendation_specific_writers_preferred }
      })
    },
    schoolRequiredEvaluations () {
      return filterZeroArrays(this.savedSchool.letter_of_recommendation_specific_writers_title).map((lor) => {
        return { ...lor, required: !this.savedSchool.letter_of_recommendation_specific_writers_preferred }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkevaluationmixin.js